<template>
    <CodiceFeanorView tool-module="bcrypt" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
